import React, {FunctionComponent, useState} from 'react'
import {PayPalScriptProvider, PayPalButtons} from '@paypal/react-paypal-js'
import {routes} from '../../server/routes'
import {NanoId} from '../../server/model/Ids'

type Props = {
    textId: NanoId,
    onStatusChange: (status: string) => void,
    onEmailChange: (email: string) => void,
    paypalClientId: string,
}
export const PayPalComponent: FunctionComponent<Props> = ({textId, onStatusChange, onEmailChange, paypalClientId}) => {
    const initialOptions = {
        clientId: paypalClientId,
        enableFunding: 'venmo,card',
        disableFunding: 'paylater',
        dataSdkIntegrationSource: 'integrationbuilder_sc',
        currency: 'EUR',
    }
    const [message, setMessage] = useState('')
    return <div>
        <PayPalScriptProvider options={initialOptions}>
            <PayPalButtons
                style={{shape: 'rect', layout: 'vertical', tagline: false}}
                createOrder={async () => {
                    try {
                        const response = await fetch(routes.postCreateOrder.reverse({}), {
                            method: 'POST',
                            headers: {'Content-Type': 'application/json',},
                            body: JSON.stringify({
                                textId,
                            }),
                            credentials: 'include',
                        })
                        const orderData = await response.json()
                        if (orderData.id) {
                            return orderData.id
                        } else {
                            const errorDetail = orderData?.details?.[0]
                            const errorMessage = errorDetail
                                ? `${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
                                : JSON.stringify(orderData)
                            throw new Error(errorMessage)
                        }
                    } catch (error) {
                        console.error(error)
                        setMessage(`Could not initiate PayPal Checkout...${error}`)
                    }
                }}
                onApprove={async (data, actions) => {
                    try {
                        const response = await fetch(
                            routes.postCaptureOrder.reverse({}),
                            {
                                method: 'POST',
                                headers: {'Content-Type': 'application/json'},
                                body: JSON.stringify({
                                    orderId: data.orderID,
                                    textId: textId
                                }),
                                credentials: 'include',
                            },
                        )
                        const {status, email}: { status: string, email?: string } = await response.json()
                        onStatusChange(status)
                        switch (status) {
                            case 'RECOVERABLE_ERROR':
                                return actions.restart()
                            case 'NON_RECOVERABLE_ERROR':
                                setMessage('Echec du paiement')
                                break
                            case 'REQUIRES_LOGIN':
                                onEmailChange(email!)
                                break
                            case 'SUCCESS':
                                break
                        }
                    } catch (error) {
                        console.error(error)
                        setMessage('Echec du paiement')
                    }
                }}
            />
        </PayPalScriptProvider>
        <p className="text-error">{message}</p>
    </div>
}
